import React, { useEffect, useRef, useState } from "react";
import Input from "../../../Components/Input/Input";
import { fetchCountryList, getSuggestList, getViewHotel, UpdateHotelDetails } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import ViewHotelImageDetails from "./ViewHotelImage";
import "../Hotel/details.css";
import AddNewImages from "./AddNewImage";
import { clickOutSide, isEmpty } from "../../../utils/common";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper";
import { useDebounce } from "../../../Components/hooks/useDebounce";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import RichTextEditor from "../../../Components/RichTextEditor/RichText";
import { formValidation } from "../../../utils/formValidation";

const ViewHotelDetails = () => {
  const { id } = useParams();
  const [viewHotelData, setViewHotelData] = useState({});
  const [viewHotelDataErr, setViewHotelDataErr] = useState({});
  const [activeTab, setActiveTab] = useState("details");
  const [showAddImage, setShowAddImage] = useState(false);
  const [feedDataText, setFeedDataText] = useState("");
  const [msg,setMessage] = useState("");
  const [searchCityName,setSearchCityName] = useState("");
  const [countryCode,setCountryCode] = useState("");
  const [suggestions, setSuggestions] = useState([]);
      const [showSuggestions, setShowSuggestions] = useState(false);

  const navigate = useNavigate();

 const [countryList, setCountryList] = useState([]);
         const [filteredCountries, setFilteredCountries] = useState([]);
         const [isOpen, setIsOpen] = useState(false);
         const [showSource, setShowSource] = useState(false); 
         const quillRef = useRef(null);
        const outSideRefCountry = useRef(null)
       
        
        const debounceCountry = useDebounce(countryCode, 500);
       
         useEffect(() => {
           fetchCountryList()
             .then((response) => {
               setCountryList(response?.data?.data?.countries || []);
             })
             .catch((error) => {
               console.error("Failed to fetch country list:", error);
             });
         }, []);
       
         useEffect(() => {
           const filtered = countryList.filter((country) => (country?.name || "").toLowerCase().includes((debounceCountry || "").toLowerCase()));
           setFilteredCountries(filtered || [])
         }, [debounceCountry, countryList]);
   
         const handleCountrySelect = (country) => {
          setViewHotelData((prevData) => ({
            ...prevData,
            country: country.name,
            countryCode: country.iso2,
          }));

          setCountryCode(country.iso2)
          setIsOpen(false)
          setFilteredCountries([]);
        };


  const handleHotelImage = () => {
    navigate(`/hotel/View/Image`);
  };

  const viewHotel = () => {
    const param = id;
    getViewHotel(param).then((response) => {
      const hotelData = response?.data?.data;
      setViewHotelData(hotelData);
      setCountryCode(hotelData?.countryCode);
      setSearchCityName(hotelData?.cityName);
      // Set feedData as editable text
      try {
        setFeedDataText(JSON.stringify(JSON.parse(hotelData?.feedData || "{}"), null, 2));
      } catch (error) {
        console.error("Error parsing feedData:", error);
        setFeedDataText("{}");
      }
    });
  };

  useEffect(() => {
    viewHotel();
  }, []);

  const handleFeedDataChange = (e) => {
    setFeedDataText(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if(name === "cityName"){
      setSearchCityName(value);
      setViewHotelData((prev) => ({
        ...prev,
        cityName: "",
      }))
      return;
    }
    if(name === "countryCode"){
      setCountryCode(value);
      setViewHotelData((prev) => ({
        ...prev,
        countryCode: "",
      }))
      return;
    }
  
    setViewHotelData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdateDetails = () => {
    const error = formValidation(viewHotelData);
    console.log("error",error)
    setViewHotelDataErr(error)
    if(!isEmpty(error)) return;
  
    try {
      // Validate feedData
      const parsedFeedData = JSON.parse(feedDataText);
  
      // Include parsed feedData in the update
      const param = {
        ...viewHotelData,
        id,
        description: viewHotelData?.description, // HTML-rich text
      };
  
      console.log("param", param);
  
      UpdateHotelDetails(param)
        .then((response) => {
          if (response?.data?.status) {
            setMessage({ type: "success", msg: "Hotel details updated successfully!" });
          } else {
            setMessage({ type: "error", msg: response?.data?.message || "Failed to update hotel details." });
          }
        })
        .catch((error) => {
          console.error("Error updating hotel details:", error);
          setMessage({ type: "error", msg: error?.response?.data?.message || "Something's amiss, please try again." });
        });
    } catch (error) {
    }
  };
  

  const AddNewImage = () => {
    setShowAddImage((prev) => !prev);
    
  };

  useEffect(() =>{
 if( isEmpty(msg)) return;

 setTimeout(() =>{
  setMessage({})
 },5000)

  },[msg])

  const fetchSuggestions = (query, identifier,type) => {
        getSuggestList(query, identifier,type)
          .then((resp) => {
            console.log("API Response:", resp?.data.data.suggestions); // Debug response
            if (resp?.data.data.suggestions) {
              setSuggestions([...resp?.data.data.suggestions]);
             // setShowSuggestions(true);
             
            } else {
              setSuggestions([]);
              setShowSuggestions(false); // Handle no suggestions case
              
            }
          })
          .catch((error) => console.error("Error fetching suggestions:", error));
      };

      const debounceValue = useDebounce(searchCityName, 500);

     useEffect(() =>{
        fetchSuggestions(debounceValue, "loc","1");
         },[debounceValue])

         const handleDescriptionChange = (value) => {
          setViewHotelData((prevData) => ({
            ...prevData,
            description: value, // Update description in viewHotelData
          }));
        }
       
        const handleContentChange = (value) => {
          // setContent(value);
        };
      
        const toggleSourceView = () => {
          setShowSource((prev) => !prev);
        };

        useEffect(()=>{
          if(!outSideRefCountry) return
          clickOutSide(outSideRefCountry,()=>setIsOpen(false));
          return  clickOutSide(outSideRefCountry,()=>setIsOpen(false),"remove")
        },[outSideRefCountry]);

        

    return (
    <>
      <div className="main_container" style={{ padding: "30px" }}>
      <div className="userlist_head">
            <div className="userlist_heading">
              <div className="userlist_left">
                <label>Hotel Details</label>
              </div>
            </div>
            </div>
      
      
        <div className="subadmin_container flex column gap-20" style={{ padding: "30px" }}>
        <div className="">
            <div className="tabs flex gap-10">
              <button
                className={`tab ${activeTab === "details" ? "active" : ""}`}
                onClick={() => setActiveTab("details")}
              >
                HOTEL
              </button>
              <button
                className={`tab ${activeTab === "images" ? "active" : ""}`}
                onClick={() => setActiveTab("images")}
              >
                IMAGE
              </button>
           
            </div>
          </div>
         
            {!isEmpty(msg) && (
          <AlertWrapper className={`${msg.type} globle`}>
            <span className="close" onClick={() => setMessage({})}>
              ×
            </span>
            {msg.msg}
          </AlertWrapper>
        )}

          {activeTab === "details" && (
            <div style={{flex:"1 1 100%"}}>
              <div className="flex gap-10">
                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Hotel Code:</label>
                  </div>
                  <Input
                    type="text"
                  
                    placeholder="Hotel Code"
                    name="code"
                    value={viewHotelData?.code || ""}
                    readOnly
                  />
                   {viewHotelDataErr?.code && (
                  <p className="error fs-12 mt-10">{viewHotelDataErr?.code}</p>
                )}
                </div>
               
                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Hotel Name:</label>
                  </div>
                  <Input
                    type="text"
                
                    placeholder="Hotel Name"
                    name="name"
                    value={viewHotelData?.name || ""}
                    onChange={handleChange}
                  />
                    {viewHotelDataErr?.name && (
                  <p className="error fs-12 mt-10">{viewHotelDataErr?.name}</p>
                )}
                </div>

                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Check In:</label>
                  </div>
                  <Input
                    type="time"
                   
                    placeholder="Check In Time"
                    name="checkInTime"
                    value={viewHotelData?.checkInTime || ""}
                    onChange={handleChange}
                  />
                    {viewHotelDataErr?.checkInTime && (
                  <p className="error fs-12 mt-10">{viewHotelDataErr?.checkInTime}</p>
                )}
                </div>
              
                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Check Out:</label>
                  </div>
                  <Input
                    type="time"
                   
                    placeholder="Check Out Time"
                    name="checkOutTime"
                    value={viewHotelData?.checkOutTime || ""}
                    onChange={handleChange}
                  />
                    {viewHotelDataErr?.checkOutTime && (
                  <p className="error fs-12 mt-10">{viewHotelDataErr?.checkOutTime}</p>
                )}
                </div>
              </div>

              <div className="flex gap-10 mt-20">
                <div style={{flex:"1 1 50%"}}>
                  
                  
                  <div className="labelname mb-5">
                    <label className="fw-bold">City Name:</label>
                  </div>

                 
                  <Input
                    type="text"
                 
                    placeholder="City Name"
                    name="cityName"
                    value={searchCityName || ""}
                    onChange={handleChange}
                    onFocus={() =>setShowSuggestions(true)}
                  />
                    {viewHotelDataErr?.cityName && (
                  <p className="error fs-12 mt-10">{viewHotelDataErr?.cityName}</p>
                )}
                   { showSuggestions && suggestions.length > 0 && (
     <div style={{position:"absolute"}}>
       <AutoSuggestion
    fromCityList={suggestions}
     //className="hotelCityName"
 
    setCityName={(name) =>
     {
      setViewHotelData((prev) => ({
        ...prev,
        cityName: name,
      }))
      setSearchCityName(name)
     }
    }
    setCityId={(id) =>
      setViewHotelData((prev) => ({
        ...prev,
        cityId: id, // Set the selected city ID
      }))
    }
   
    setShowCity={setShowSuggestions}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
  />

     </div>
                  )}

             
                </div>

                
                    
                

                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Geo Point:</label>
                  </div>
                  <Input
                    type="text"
                  
                    placeholder="Geo Point"
                    name="geoPoint"
                    value={viewHotelData?.geoPoint || ""}
                   
                  />
                    {viewHotelDataErr?.geoPoint && (
                  <p className="error fs-12 mt-10">{viewHotelDataErr?.geoPoint}</p>
                )}
                </div>
                <div  style={{flex:"1 1 50%",position:"relative"}} ref ={outSideRefCountry}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Country Code:</label>
                  </div>
                  <Input
                    type="text"
                   
                    placeholder="Country Code"
                    name="countryCode"
                    value={countryCode || ""}
                    onChange={handleChange}
                    onFocus={()=>setIsOpen(true)}
                  />
                   {viewHotelDataErr?.countryCode && (
                  <p className="error fs-12 mt-10">{viewHotelDataErr?.countryCode}</p>
                )}
                    {filteredCountries.length > 0 && isOpen && (
                <div className="dropdown mt-10" style={{maxWidth:"330px",width:"100%",background:"#fff",position:"absolute"}}>
                  {filteredCountries.map((country) => (
                    <div
                      key={country.iso2}
                      className="dropdown-item fs-14"
                      style={{paddingBottom:"5px",borderBottom:"1px solid #8080803d",paddingTop:"5px",cursor:"pointer"}}
                      onClick={() => handleCountrySelect(country)}
                    >
                      {country.name} ({country.iso2})
                    </div>
                  ))}
                </div>
              )}
             
                </div>

              
             
              </div>

           
           
           
             

              

             

              <div className="flex gap-10 mt-20">
                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Phone:</label>
                  </div>
                  <Input
                    type="text"
                   
                    placeholder="Phone"
                    name="phone"
                    value={viewHotelData?.phone || ""}
                    onChange={handleChange}
                  />
                  
                </div>
                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname">
                    <label className="fw-bold">Email:</label>
                  </div>
                  <Input
                    type="text"
                    onChange={handleChange}
                    placeholder="Email"
                    name="email"
                    value={viewHotelData?.email || ""}
                    
                  />
                </div>
                
                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Fax:</label>
                  </div>
                  <Input
                    type="text"
                  
                    placeholder="Fax"
                    name="fax"
                    value={viewHotelData?.fax || ""}
                    onChange={handleChange}
                  />
                </div>
                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Star Rating:</label>
                  </div>
                  <Input
                    type="text"
                 
                    placeholder="Star Rating"
                    name="starRating"
                    value={viewHotelData?.starRating || ""}
                    onChange={handleChange}
                  />
                </div>

               
              </div>

              <div className="flex gap-10 mt-20">

                 
               
               
                <div className="input-field" style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Status:</label>
                  </div>
                  <select
                  
                    className="input_select_field"
                    name="active"
                    value={viewHotelData?.active || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select Status</option>
                    <option value={true}>ACTIVE</option>
                    <option value={false}>INACTIVE</option>
                  </select>
                </div>  

                 <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Pin Code:</label>
                  </div>
                  <Input
                    type="text"
                   
                    placeholder="Pin Code"
                    name="pinCode"
                    value={viewHotelData?.pinCode || ""}
                    onChange={handleChange}
                  />
                </div>
                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Address:</label>
                  </div>
                  <Input
                    type="text"
                
                    placeholder="Address"
                    name="address"
                    value={viewHotelData?.address || ""}
                    onChange={handleChange}
                  />
                </div>

                <div style={{flex:"1 1 50%"}}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Feed Source:</label>
                  </div>
                  <Input
                    type="text"

                    placeholder="Feed Source"
                    name="feedSource"
                    value={viewHotelData?.feedSource || null}
                    onChange={handleChange}
                  />
                </div>


               
              </div>

              <div className="flex gap-10 mt-20">
              <div style={{flex:"1 1 50%"}}>
                 
                <RichTextEditor onContentChange={handleDescriptionChange} initialContent={viewHotelData?.description}></RichTextEditor>
                  
          
          
          </div> 
               
               </div>
              <button className="userlist_btn mt-20" onClick={handleUpdateDetails}>
                  Update Details
                </button>
             
            </div>
          )}

          {activeTab === "images" && (
            <div className="category-section">
                <button className="userlist_btn mb-5" onClick={AddNewImage}>
                  Add New Image
                </button>
                </div>
                )}

          {showAddImage && activeTab === "images" && 
           <AddNewImages hotelCode = {viewHotelData?.code} />
         
         }
          {activeTab === "images" && (
            <div>
                
            <ViewHotelImageDetails hotelCode = {viewHotelData?.code} setShowAddImage={setShowAddImage} />

            </div>
           
          )}
        </div>
      </div>
    </>
  );
};

export default ViewHotelDetails;
